import { useSelector } from 'react-redux';

import {
  selectAppPreviousRoute,
  selectAppRoute,
  selectFidelityCardIdFromKiosk,
  selectIsDevToolsEnabled,
  selectIsFirstTimeCatalogShowed,
  selectIsFooterTutorialDisplayed,
  selectIsFunctionalityExplanationDisplayed,
  selectIsHostMocked,
  selectIsKioskSessionResetInProgress,
  selectIsLocaleEditMode,
  selectIsSelectProductTooltipShown,
  selectIsTasteIdGuideShown,
  selectIsTastePathOnboardingShown,
  selectIsTestResultView,
  selectIsThirdPartyConnectModalShown,
  selectLocale,
  selectServiceProductCategory,
  selectShouldHideDownloadAppCard,
  selectShouldShowGamificationStartPage,
  selectShouldShowScanBarcode,
  selectShouldShowTastePathStartPage,
  selectThirdPartyConnectModalScenario,
} from '@lib/core/service/selectors';
import { setHideGamificationStartPage, setServiceLocale } from '@lib/core/service/slices';
import { languages } from '@lib/tools/locale/utils/consts';
import { useTypedDispatch } from '@lib/tools/views/hooks/useTypedDispatch';

export const useApp = () => {
  const dispatch = useTypedDispatch();

  const locale = useSelector(selectLocale);

  const handleSetServiceLocale = (languageCode: string) => dispatch(setServiceLocale(languageCode));

  const handleHideGamificationStartPage = () => dispatch(setHideGamificationStartPage());

  const isLocaleRtl = () => {
    const rtlLanguages = [languages.ARABIC, languages.HEBREW];
    return rtlLanguages.some(language => locale.startsWith(language));
  };
  return {
    fidelityCardIdFromKiosk: useSelector(selectFidelityCardIdFromKiosk),
    handleHideGamificationStartPage,
    handleSetServiceLocale,
    isDevToolsEnabled: useSelector(selectIsDevToolsEnabled),
    isFirstTimeCatalogShowed: useSelector(selectIsFirstTimeCatalogShowed),
    isFooterTutorialDisplayed: useSelector(selectIsFooterTutorialDisplayed),
    isFunctionalityExplanationDisplayed: useSelector(selectIsFunctionalityExplanationDisplayed),
    isHostMocked: useSelector(selectIsHostMocked),
    isKioskSessionResetInProgress: useSelector(selectIsKioskSessionResetInProgress),
    isLayoutRightToLeft: isLocaleRtl(),
    isLocaleEditMode: useSelector(selectIsLocaleEditMode),
    isSelectProductTooltipShown: useSelector(selectIsSelectProductTooltipShown),
    isTasteIdGuideShown: useSelector(selectIsTasteIdGuideShown),
    isTastePathOnboardingShown: useSelector(selectIsTastePathOnboardingShown),
    isTestResultView: useSelector(selectIsTestResultView),
    isThirdPartyConnectModalShown: useSelector(selectIsThirdPartyConnectModalShown),
    locale,
    previousRoute: useSelector(selectAppPreviousRoute),
    productCategory: useSelector(selectServiceProductCategory),
    route: useSelector(selectAppRoute),
    scenarioForThirdPartyConnectModalOpened: useSelector(selectThirdPartyConnectModalScenario),
    shouldHideDownloadAppCard: useSelector(selectShouldHideDownloadAppCard),
    shouldShowGamificationStartPage: useSelector(selectShouldShowGamificationStartPage),
    shouldShowScanBarcode: useSelector(selectShouldShowScanBarcode),
    shouldShowTastePathStartPage: useSelector(selectShouldShowTastePathStartPage),
  };
};
